import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { useState } from 'react';
import styled from 'styled-components';
import { styleVariables } from '@lib/common';
import { TextOptionInput } from '@lib/common';
import { Row, Col } from 'antd';
import { SubmissionBaseQuestion } from './base-question.component';
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
var CorrectAnswerContainer = styled.div.withConfig({
  displayName: "fill-in-blankcomponent__CorrectAnswerContainer",
  componentId: "sc-1pme5tz-0"
})(["color:", ";"], styleVariables.colors.gray11);
var IndexColumn = styled(Col).withConfig({
  displayName: "fill-in-blankcomponent__IndexColumn",
  componentId: "sc-1pme5tz-1"
})(["color:", ";"], styleVariables.colors.blue4);
var InputFieldColumn = styled(Col).withConfig({
  displayName: "fill-in-blankcomponent__InputFieldColumn",
  componentId: "sc-1pme5tz-2"
})([""]);
var ScoreColumn = styled(Col).withConfig({
  displayName: "fill-in-blankcomponent__ScoreColumn",
  componentId: "sc-1pme5tz-3"
})(["text-align:center;"]);
var AnswerContainer = styled(Row).withConfig({
  displayName: "fill-in-blankcomponent__AnswerContainer",
  componentId: "sc-1pme5tz-4"
})(["display:flex;align-items:center;margin-top:8px;.ant-col-1{min-width:35px;text-align:center;}"]);
export var SubmissionFillInBlankQuestion = function SubmissionFillInBlankQuestion(props) {
  var question = props.question,
      label = props.label,
      disabled = props.disabled,
      onChangeAnswer = props.onChangeAnswer,
      answers = props.answers;

  var _useState = useState({}),
      value = _useState[0],
      setValue = _useState[1];

  return /*#__PURE__*/_jsx(SubmissionBaseQuestion, _objectSpread(_objectSpread({}, props), {}, {
    children: question.answers.map(function (answer, index) {
      var _answerValue$value, _answerValue$value2;

      var correctAnswer = question.correctAnswers && question.correctAnswers.find(function (c) {
        return c.answerId === answer.id.toString();
      });
      var answerValues = answers && answers.length > 0 && (answers === null || answers === void 0 ? void 0 : answers.filter(function (a) {
        return a.answerBlankId === answer.id.toString();
      }));
      var answerValue = answerValues && answerValues[answerValues.length - 1];
      return /*#__PURE__*/_jsx(CorrectAnswerContainer, {
        children: /*#__PURE__*/_jsxs(AnswerContainer, {
          gutter: 8,
          children: [/*#__PURE__*/_jsxs(IndexColumn, {
            span: 1,
            children: ["(", index + question.index, ")"]
          }), /*#__PURE__*/_jsx(InputFieldColumn, {
            span: 19,
            children: /*#__PURE__*/_jsx(TextOptionInput, {
              disabled: disabled,
              isHiddenDelete: true,
              defaultValue: answerValue === null || answerValue === void 0 ? void 0 : (_answerValue$value = answerValue.value) === null || _answerValue$value === void 0 ? void 0 : _answerValue$value.text,
              value: value["".concat(answer.id)] || value["".concat(answer.id)] === '' ? value["".concat(answer.id)] : answerValue === null || answerValue === void 0 ? void 0 : (_answerValue$value2 = answerValue.value) === null || _answerValue$value2 === void 0 ? void 0 : _answerValue$value2.text,
              onChange: function onChange(e) {
                setValue(_objectSpread(_objectSpread({}, value), {}, _defineProperty({}, "".concat(answer.id), e.target.value.toString())));
                onChangeAnswer(answer.id.toString(), e.target.value);
              },
              hasImage: true,
              onShowingUploadImageModal: function onShowingUploadImageModal() {
                throw new Error('Function not implemented.');
              }
            })
          }), correctAnswer && correctAnswer.score && /*#__PURE__*/_jsxs(ScoreColumn, {
            span: 3,
            children: [correctAnswer.score, " ", label.score]
          })]
        })
      }, index);
    })
  }));
};